export enum AlertPriority {
  LOWEST = 'lowest',
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  URGENT = 'urgent',
  CRITICAL = 'critical',
}

export enum AlertActions {
  VALIDATE_EMAIL = 'validate_email',
}

export type IGlobalAlert = {
  _id: string;
  priority?: AlertPriority;
  title?: string;
  body?: string;
  action?: {
    text: string;
    fcn: () => void;
  };
  data?: any;
  dismiss?: boolean;
  dismissed?: boolean;
};
